import React, { Fragment, useState } from "react";
import styles from "./CreateNewCategory.module.scss";
import { Container, Row, Col, Input, Label, Button, Form, FormGroup, Table } from "reactstrap";
import productImg from "../../../../assets/images/WholesalerPortalImages/CategoryManagement/productImg.png";
import SelectProductsModal from "./SelectProductsModal/SelectProductsModal";

const products = [
    { id: 1, name: "Blue Colored Headphones", productId: "#123456789", stock: 300, image: productImg },
    { id: 2, name: "Blue Colored Headphones", productId: "#123456789", stock: 300, image: productImg },
    { id: 3, name: "Blue Colored Headphones", productId: "#123456789", stock: 300, image: productImg },
    { id: 4, name: "Blue Colored Headphones", productId: "#123456789", stock: 300, image: productImg },
    { id: 5, name: "Blue Colored Headphones", productId: "#123456789", stock: 300, image: productImg },
    { id: 6, name: "Blue Colored Headphones", productId: "#123456789", stock: 300, image: productImg },
];

const CreateNewCategory = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedProducts, setSelectedProducts] = useState(products);

    const chunkArray = (array, size) => {
        return array.reduce((acc, _, i) => {
            if (i % size === 0) acc.push(array.slice(i, i + size));
            return acc;
        }, []);
    };

    const productChunks = chunkArray(selectedProducts, 2);

    // const handleAddProducts = (newProducts) => {
    //     setSelectedProducts((prevProducts) => [...prevProducts, ...newProducts]);
    // };

    const handleAddProducts = (newProducts) => {
        setSelectedProducts((prevProducts) => {
            const updatedProducts = [...prevProducts, ...newProducts.filter(
                (newProduct) => !prevProducts.some((prod) => prod?.id === newProduct?.id)
            )];
            return updatedProducts;
        });
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.newCategorySection}>
                <div className={styles.sectionTitle}>
                    <h5 className={styles.sectionSubHeading}>Basic Information</h5>
                </div>

                <Row className={styles.newCategoryFormRow}>
                    <Form className={styles.formSection}>
                        <FormGroup>
                            <Row className={styles.formGroupRow}>
                                <Col lg={3} xl={2} >
                                    <Label for="categoryName">Category Name:</Label>
                                </Col>
                                <Col lg={4}>
                                    <Input
                                        type="text"
                                        id="categoryName"
                                        placeholder="Enter Category Name"
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row className={styles.formGroupRow}>
                                <Col lg={3} xl={2}>
                                    <Label for="description">Description:</Label>
                                </Col>
                                <Col lg={9} xl={10}>
                                    <Input
                                        type="textarea"
                                        id="description"
                                        placeholder="Enter Description"
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row className={styles.formGroupRow}>
                                <Col lg={3} xl={2}>
                                    <Label for="categoryImage">Category Image:</Label>
                                </Col>
                                <Col lg={4}>
                                    <Input
                                        type="text"
                                        id="categoryImage"
                                        placeholder="Enter Category Image"
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row className={styles.formGroupRow}>
                                <Col lg={3} xl={2}>
                                    <Label for="parentCategory">Parent Category:</Label>
                                </Col>
                                <Col lg={4}>
                                    <Input type="select" id="parentCategory">
                                        <option>Choose from dropdown menu</option>
                                        <option>Choose from dropdown menu</option>
                                        <option>Choose from dropdown menu</option>
                                    </Input>
                                </Col>
                            </Row>
                        </FormGroup>
                    </Form>
                </Row>

                <div className={styles.sectionTitle}>
                    <h5 className={styles.sectionSubHeading}>Product Selection</h5>
                </div>

                <Row className={styles.productSelectionRow}>
                    <div className={styles.addProductContainer}>
                        <Button
                            color="info"
                            className={styles.addProductButton}
                            onClick={toggleModal}
                        >
                            Add Products
                        </Button>
                    </div>

                    <div className={styles.totalSelectedProducts}>
                        Total Selected Product: <span>{selectedProducts.length}</span>
                    </div>

                    <div className={styles.tableContainer}>
                        <Table bordered className={styles.productTable}>
                            <thead>
                                <tr>
                                    <th>Serial no.</th>
                                    <th>Product</th>
                                    {products.length > 1 && (
                                        <>
                                            <th>Serial no.</th>
                                            <th>Product</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {productChunks.map((chunk, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {chunk.map((product) => (
                                            <Fragment key={product.id}>
                                                <td key={`serial-${product.id}`}>{product.id}</td>
                                                <td key={`product-${product.id}`}>
                                                    <Row className={styles.productRow}>
                                                        <Col xs="4">
                                                            <div className={styles.productImageContainer}>
                                                                <img src={product.image} alt={product.name} />
                                                            </div>
                                                        </Col>
                                                        <Col xs="8">
                                                            <div className={styles.productDetailsContainer}>
                                                                <div className={styles.productName}>
                                                                    {product.name}
                                                                </div>
                                                                <div className={styles.productId}>
                                                                    Product ID: <span>{product.productId}</span>
                                                                </div>
                                                                <div className={styles.productStock}>
                                                                    Stock: <span>{product.stock}</span>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </td>
                                            </Fragment>
                                        ))}
                                        {products.length > 1 && chunk.length < 2 && (
                                            <>
                                                <td></td>
                                                <td></td>
                                            </>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Row>
            </Container>

            <div className={styles.createBtnContainer}>
                <Button type="button" color="primary" className={styles.createBtn}>
                    Create Category
                </Button>
            </div>

            <SelectProductsModal
                isModalOpen={isModalOpen}
                toggleModal={toggleModal}
                searchQuery={searchQuery}
                handleSearchChange={handleSearchChange}
                handleAddProducts={handleAddProducts}
            />
        </div>
    );
};

export default CreateNewCategory;